module.exports = __webpack_public_path__ + "img/plus.714b4b86.svg";